import { Helmet } from 'react-helmet'
import { Navigate, useNavigate } from 'react-router-dom'

import { ExpiresDate } from '~/components/ExpiresDate'
import { PageHeader } from '~/components/PageHeader'
import { SISAmountInput } from '~/components/SISAmountInput'
import { SwitchNetworkButton } from '~/components/SwitchNetworkButton'
import Tile from '~/components/Tile'
import { useGetSISTokenBalance } from '~/hooks/useGetSISTokenBalance'
import { useVESISParams } from '~/hooks/useVESISParams'
import { useLockDetails } from '~/lib/useLockDetails'

import { useLockParams } from './useLockParams'

import { ADDITIONAL_WEEK } from '~/lib/constants'
import styles from './CreateLockPage.pcss'

export function CreateLockPage() {
	const { config } = useVESISParams()

	const navigate = useNavigate()

	const { data: lock, isFetched, isLoading } = useLockDetails()

	const { amount, amountBN, weeks, setAmount, setWeeks } = useLockParams()

	const { data: balance } = useGetSISTokenBalance()

	if (lock && isFetched) {
		return <Navigate to="/vesis" />
	}

	const amountEmpty = !amountBN?.gt(0)

	let insufficientBallance = false
	if (balance && amountBN) {
		insufficientBallance = amountBN.gt(balance)
	}

	let buttonText = 'Confirm Lock'
	if (amountEmpty) {
		buttonText = 'Enter SIS Amount'
	} else if (insufficientBallance) {
		buttonText = 'Insufficient SIS balance'
	} else if (!weeks) {
		buttonText = 'Enter Weeks Prolongation'
	}

	return (
		<Tile>
			<Helmet>
				<title>Create Lock</title>
			</Helmet>

			<Tile.Header>
				<PageHeader
					title="veSIS Staking"
					backLink={`/vesis/${config.slug}`}
					onQuestionClick={() => {
						window.open(
							'https://docs.symbiosis.finance/liquidity-providers/vesis',
							'_blank'
						)
						// TODO show bubbles
					}}
				/>
			</Tile.Header>

			<div className={styles.content}>
				<SISAmountInput
					balance={balance}
					value={amount}
					onChange={setAmount}
				/>

				<ExpiresDate
					className={styles.date}
					value={weeks}
					addWeek={ADDITIONAL_WEEK}
					onChange={setWeeks}
				/>
			</div>

			<Tile.Footer>
				<SwitchNetworkButton
					block
					disabled={
						amountEmpty ||
						!weeks ||
						insufficientBallance ||
						isLoading
					}
					color="black"
					onClick={() => {
						navigate(
							`/vesis/${config.slug}/confirm?amount=${amount}&weeks=${weeks}`
						)
					}}
					requiredChainId={config.chain.id}
				>
					{buttonText}
				</SwitchNetworkButton>
			</Tile.Footer>
		</Tile>
	)
}
